/**
 * @Author wutao
 * @description 课件新增编辑页面
 * @Date 2020/2/14
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool'
import { Spin } from "antd";
import { WizTableForm } from '@/containers/common'

let { WizContainer, modelUtils, ossFileUtils, WizFileUpload } = framework_tool;
let { WizCard, WizForm, WizSpin, Wizmessage } = component_tool;
let { Session } = utils_tool;

const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "teacherRole" } })
const coursewareConfig = WizTableForm.Config.courseware(this, { apiParams: {} })

class ScheduleDetail extends WizContainer {

  componentName = 'ScheduleDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let orientationIsRequired = false;
    if (history.location && history.location.pathname === '/program/scheduleList/scheduleDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        const { supports } = initialValue;
        if (supports) {
          supports.forEach((support) => {
            if (support === 1) {
              orientationIsRequired = true;
            }
          });
        }
        Session.set('scheduleDetailUpd', initialValue)
      } else {
        initialValue = Session.get('scheduleDetailUpd') || {};
        const { supports } = initialValue;
        if (supports) {
          supports.forEach((support) => {
            if (support === 1) {
              orientationIsRequired = true;
            }
          });
        }
      }
    } else if (history.location && history.location.pathname === '/program/scheduleList/scheduleDetailAdd') {
      if (history.location && history.location.record && (history.location.record.code || history.location.record.code === 0)) {
        initialValue.type = history.location.record.code
        Session.set('scheduleDetailAdd', initialValue)
      } else {
        initialValue = Session.get('scheduleDetailAdd') || {};
      }
    }
    this.state = {
      orientationRequired: orientationIsRequired,
      uploadDisabled: false,
      scheduleId: initialValue.id,
    };
    this.orientationIsRequired = orientationIsRequired;
    this.initialValue = initialValue;
    this.initialValue.personInfo = [];
    this.initialValue.courseware = [];
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/program/scheduleList/scheduleDetailUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('scheduleDetailUpd', initialValue)
      } else {
        initialValue = Session.get('scheduleDetailUpd') || {};
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({scheduleId:initialValue.id})
      this._componentDidMount()
    }
  }

  _componentDidMount() {
    const { history } = this.props;
    if (this.initialValue && this.initialValue.lectureIds && this.initialValue.lectureIds.length > 0) {
      this.getPersonInfoByPersonIdList()
    }
    if (this.initialValue && this.initialValue.coursewareId && this.initialValue.coursewareId != -1) {
      this.getCoursewareById();
    }
  }

  propsAndStateOnChange = {
    addSchedule: this._addScheduleOver.bind(this),
    updateSchedule: this._updateScheduleOver.bind(this),
    personInfo: this._getPersonInfoOver.bind(this),
    courseware: this._getCoursewareByIdOver.bind(this),
  };

  /**获取对应的讲师数据，讲师选择组件需要显示默认值 */
  getPersonInfoByPersonIdList() {
    this.doAction({
      path: 'personManage/getPersonInfoByPersonIdList',
      payload: {
        key: 'getPersonInfoByPersonIdList',
        apiParams: {
          personIdList: this.initialValue.lectureIds,
        }
      }
    });
  }

  /**查看时时获取对应的评语考核内容明细数据 */
  getCoursewareById() {
    this.doAction({
      path: 'coursewareManagement/selectOneById',
      payload: {
        key: 'coursewareManagement@coursewareInfo',
        apiParams: {
          id: this.initialValue.coursewareId,
        }
      }
    });
  }

  /**
   * 将查询到的人员选项加载到记录中
   */
  _getPersonInfoOver(nextProps, nextState) {
    let personInfo = nextProps.personInfo.data;
    if (nextProps.personInfo.code == 1 && personInfo && personInfo.length) {
      this.initialValue.personInfo = personInfo;
    }
    return true;
  }

  /**
   * 查询到的课件信息
   */
  _getCoursewareByIdOver(nextProps, nextState) {
    let courseware = nextProps.courseware.data;
    if (nextProps.courseware.code == 1 && courseware && courseware.id && courseware.name) {
      this.initialValue.courseware = [courseware];
    }
    return true;
  }

  _changeOrientationIsRequired = (from, value) => {
    let orientationIsRequired = false;
    if (value) {
      value.forEach((support) => {
        orientationIsRequired = true;
      });
    }
    this.setState({
      orientationRequired: orientationIsRequired,
    });
  };

  /**
   * 课件新增成功返回原页面，失败弹出提示
   */
  _addScheduleOver(nextProps, nextState) {
    if (nextProps.addSchedule.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/program/scheduleList');
    } else {
      wizNotice.error('提交失败：' + nextProps.addSchedule.msg);
    }
    return true;
  }

  /**
   * 课件修改成功返回原页面，失败弹出提示
   */
  _updateScheduleOver(nextProps, nextState) {
    if (nextProps.updateSchedule.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/program/scheduleList');
    } else {
      wizNotice.error('提交失败：' + nextProps.updateSchedule.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (key === 'waterMark') {
        if (value === null || value === undefined || value.length === 0) {
          fitterValues[key] = 1;
        } else {
          fitterValues[key] = value[0];
        }
      } else if (key === 'endTime' && value != null && value != undefined) {
        fitterValues[key] = value.format("YYYY-MM-DD HH:mm:ss");
      } else if (key === 'fileId') {
        if (value != null && value != undefined && value instanceof Array && value.length > 0) {
          fitterValues[key] = value[0].fileId;
        } else {
          fitterValues[key] = "";
        }
      } else if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    return fitterValues;
  }

  /**
   * 保存/更新 课件信息
   * @param values
   * @private
   */
  _saveSchedule(values) {
    const { history } = this.props;
    let apiPath = "scheduleManagement/add";
    let payloadKey = "addSchedule";
    if (history.location && history.location.pathname === '/program/scheduleList/scheduleDetailUpd') {
      apiPath = "scheduleManagement/update";
      payloadKey = "updateSchedule";
    }
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: apiPath,
      payload: {
        key: payloadKey,
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  /**讲师验证 */
  lecturesValidator = (rule, value, callback) => {
    //const { getFieldValue } = this.props.form; //可以获取form其他的值getFieldValue('a')
    if (value && value.length > 10) {
      callback('讲师最多选择10个')
    }
    // 必须总是返回一个 callback，否则 validateFields 无法响应
    callback();
  }

  _scheduleColumns = () => {
    const { orientationRequired } = this.state;
    let columns = []
    let initialValue = this.initialValue;
    const { id, type, status, supports, orientation, downType, duration, preventOnHook, endTime, waterMark } = initialValue;
    let initialStatus = 0;
    let initialSupports = [0, 1];
    let initialOrientation = 2;
    let initialDownType = [0, 1];
    let initialDuration, initialPreventOnHook = 0;

    let initialWaterMark = [];
    let initialEndTime = null;
    if (initialValue && id) {
      initialStatus = status;
      initialSupports = supports;
      initialOrientation = orientation;
      initialDownType = downType;
      initialDuration = duration;
      initialPreventOnHook = preventOnHook
      if (waterMark != null && waterMark != -1 && waterMark != 1) {
        initialWaterMark.push(0);
      }
      if (endTime) {
        initialEndTime = endTime;
      }
    }
    let _baseColumns1 = [
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.id
        },
        name: "id"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.delFlag
        },
        name: "delFlag"
      },
      {
        formItem: {
          type: "hidden",
          initialValue: initialValue.code
        },
        name: "code"
      },
      {
        title: "文件格式",
        name: "type",
        dict: [
          { code: 0, codeName: "视频" },
          // { code: 1, codeName: "语音" },
          { code: 2, codeName: "H5" },
          { code: 3, codeName: "PPT" },
          { code: 4, codeName: "PDF" },
          { code: 5, codeName: "SCORM" },
          {code: 10, codeName: "附件"},
          {code: 11, codeName: "文档"},
          {code: 12, codeName: "图片"},
          {code: 13, codeName: "URL"},
          {code: 14, codeName: "迁移的scorm课程包"},
        ],
        formItem: {
          type: "select",
          initialValue: initialValue.type,
          disabled: true,
          rules: [{
            required: true,
            message: '请选择文件格式'
          }],
        }
      },
      {
        title: "名称",
        name: "name",
        formItem: {
          initialValue: initialValue.name,
          rules: [{
            required: true,
            message: '请输入名称',
          }, {
            max: 50,
            message: '名称长度不能超过50个字符'
          }],
          placeholder: "请输入名称"
        }
      },
      {
        title: "防挂机时长(分)",
        name: "preventOnHook",
        formItem: {
          type: 'number',
          precision: 0,
          initialValue: initialPreventOnHook,
          min: 0,
          max: 9999
        }
      },
      {
        title: "时长(分)",
        name: "duration",
        formItem: {
          type: 'number',
          precision: 0,
          initialValue: initialDuration,
          min: 0,
          max: 9999
        }
      },
      // {
      //   title: '有效截至日期',
      //   name: 'endTime',
      //   formItem: {
      //     type: 'datetime',
      //     initialValue: initialEndTime,
      //   },
      // },
      {
        title: "支持平台",
        name: "supports",
        dict: [
          { code: 0, codeName: "PC" },
          { code: 1, codeName: "APP" }
        ],
        formItem: {
          rules: [{ required: true, message: '请选择支持平台' }],
          type: "checkbox",
          initialValue: initialSupports,
        }
      },
      {
        title: "课件方向",
        name: "orientation",
        dict: [
          { code: 0, codeName: "竖屏" },
          { code: 1, codeName: "横屏" },
          { code: 2, codeName: "都支持" }
        ],
        formItem: {
          type: "hidden",
          initialValue: initialOrientation,
          rules: [{
            required: orientationRequired
          }],

        }
      },
      {
        title: "支持下载",
        name: "downType",
        dict: [
          { code: 0, codeName: "PC下载" },
          { code: 1, codeName: "APP离线" }
        ],
        formItem: {
          type: "hidden",
          initialValue: initialDownType
        }
      },
    ]
    let _baseColumns2 = [

      {
        title: "添加水印",
        name: "waterMark",
        formItem: {
          type: 'checkbox',
          dict: [{ codeName: ' ', code: 0 }],
          rules: [],
          initialValue: initialWaterMark,
        },
      },
      {
        title: "是否允许拖拽",
        name: "drag",
        dict: [
          { code: 0, codeName: "不允许" },
          { code: 1, codeName: "允许" }
        ],
        formItem: {
          type: "hidden",
          initialValue: initialValue && initialValue.drag ? initialValue.drag : 0,
        }
      },
      {
        title: "课件相对路径",
        name: "relativePath",
        formItem: {
          type: [3, 4].includes(initialValue.type) ? 'hidden' : '',
          initialValue: initialValue.relativePath,
          placeholder: "请输入课件相对路径【如：***.mp3/ ***.mp4/ ***/***/  ...】"
        }
      },
      {
        title: "课件上传",
        name: "fileId",
        dataIndex: "fileId",
        formItem: {
          accept: ".jpg, .jpeg, .png",
          max: 1,
          type: 'custom',
          render: (record, form) => {
            record = initialValue;
            const { getFieldDecorator } = form;
            let fileId = null;
            if (record && record.fileId) {
              fileId = record.fileId;
            }
            // 类型判断
            let acceptType = () => {
              let typeVal = initialValue.type
              switch (typeVal) {
                case 0:
                  return '.zip, .mp4'
                case 3:
                  return '.ppt,.pptx'
                case 4:
                  return '.pdf'
                default:
                  return '.zip'
              }
            }

            return (<>
              {
                getFieldDecorator('fileId', {
                  initialValue:
                    (record && record.fileId && record.fileId != -1) ? [
                      { fileId }
                    ] : []
                })(
                  <WizFileUpload
                    accept={acceptType()}
                    listType={'text'}
                    limit={-1}
                    courseType={initialValue.type}
                    uploadType={'courseWare'}
                    beforeUpload={(file) => {
                      let result = true;

                      // 判断是否现在为zip上传的文件
                      if (file.type.indexOf('application/x-zip-compressed') == -1 &&
                        file.type.indexOf('application/zip') == -1 && [1, 2, 5].includes(initialValue.type)
                      ) {
                        Wizmessage.error('只能上传zip文件,请重新选择!');
                        result = false;
                      }

                      // ppt 小于150m
                      if (initialValue.type === 3) {
                        let { size } = file
                        if (size / 1024 / 1024 >= 10) {
                          Wizmessage.error('PPT应小于10M');
                          result = false;
                        }
                      }

                      return result;
                    }}
                    progress={{
                      strokeColor: {
                        '0%': '#108ee9',
                        '100%': '#87d068',
                      },
                      strokeWidth: 3,
                      format: percent => `${parseFloat(percent.toFixed(2))}%`,
                    }}
                  />
                )
              }
            </>
            )
          }
        },
      },
      {
        title: "状态",
        name: "status",
        dict: [
          { code: 0, codeName: "草稿" },
          { code: 1, codeName: "发布" },
          { code: 2, codeName: "关闭" }
        ],
        formItem: {
          type: "radio",
          initialValue: initialStatus,
          disabled: true
        }
      },
      {
        title: "介绍",
        name: "intro",
        formItem: {
          type: 'textarea',
          placeholder: '请输入介绍最多输入100个字符',
          maxlength: 100,
          rules: [],
          initialValue: initialValue.intro
        },
      },
    ]
    let _coursewareColumns = [
      {
        title: "SCORM课件",
        name: "coursewareId",
        formItem: {
          ...coursewareConfig,
          placeholder: '请选择课件',
          title: '课件选择',
          diy: WizTableForm,
          initialValue: initialValue.coursewareId,
          initRows: initialValue.courseware,
          selectType: 'radio',
          rules: [{
            required: true,
            message: '请选择课件',
          }]
        },
      },
    ]
    let _platformColumns = [
      {
        title: "课件相对路径",
        name: "relativePath",
        formItem: {
          initialValue: initialValue.relativePath,
          placeholder: "请输入课件相对路径【如：***.mp3/ ***.mp4/ ***/***/  ...】"
        }
      },
    ]
    if (type != null && type != -1 && type === 5) {
      columns = [..._baseColumns1, ..._coursewareColumns, ..._baseColumns2]
    } else {
      columns = [..._baseColumns1, ..._baseColumns2]
      // columns = [..._baseColumns1, ..._platformColumns, ..._baseColumns2]

    }
    return columns;
  }

  _render() {
    const { scheduleManagementLoading, personManageLoading, coursewareManagementLoading } = this.props;
    let initialValue = this.initialValue;
    let cardTitle = '新增';
    if (initialValue && initialValue.id) {
      cardTitle = '编辑';
    }
    let columns = this._scheduleColumns();
    let onSubmit = this._saveSchedule.bind(this);
    let formProps = {
      ref: 'form',
      key: this.state.scheduleId || '', // ⭐如缓存路由需要刷新,必须加标识key
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 12 }
      },
      style: { maxWidth: '100%', width: '100%' }
    }

    return (
      <WizCard key={'schedule-detail-edit'}>
        <Spin tip={'加载中'} spinning={scheduleManagementLoading || personManageLoading || coursewareManagementLoading}>
          <WizForm key={'schedule-detail-edit-form'} className={'form-inline'} {...formProps} />
        </Spin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { scheduleManagement, coursewareManagement, personManage } = state;
  const addSchedule = modelUtils.getModelEntity(scheduleManagement, "addSchedule");
  const updateSchedule = modelUtils.getModelEntity(scheduleManagement, "updateSchedule");
  const courseware = modelUtils.getModelEntity(coursewareManagement, "coursewareManagement@coursewareInfo");
  const personInfo = modelUtils.getModelEntity(personManage, "getPersonInfoByPersonIdList");
  const load = modelUtils.getLoadingState(state, ['scheduleManagement', 'coursewareManagement', 'personManage']);
  return {
    addSchedule: addSchedule,
    updateSchedule: updateSchedule,
    courseware: courseware,
    personInfo: personInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ScheduleDetail);
